import React from 'react';
import MAP_CONFIG from '../../config/mapConfig';
import LeafletTechnicianMap from './providers/LeafletTechnicianMap';
import MapboxTechnicianMap from './providers/MapboxTechnicianMap';

const providers = {
  leaflet: LeafletTechnicianMap,
  mapbox: MapboxTechnicianMap,
};

export default function ProviderMap(props) {
  const Component = providers[MAP_CONFIG.provider] || LeafletTechnicianMap;
  return <Component {...props} />;
}
